import LinkBarButton from "./LinkBarButton"
import InternalLinkBarButton from "./InternalLinkBarButton"
import {
  buildCloudWatchDashboardsUrl,
  environment,
} from "../../config/environment"

export default function RightLinkBar() {
  return (
    <div className="fixed right-0 top-0 flex flex-col w-[280px] h-dvh mt-[2%]">
      <div className="flex flex-col w-[80%] rounded-md text-ktx-navy gap-2">
        <h2 className="text-dark-purple font-bold text-[24px] text-center">Repo Links</h2>
        <LinkBarButton linkText={environment.adminDashboardRepositoryUrl} displayText="Admin Dashboard" openNewWindow={true} />
        <LinkBarButton linkText={environment.adminBackendRepositoryUrl} displayText="Admin Backend" openNewWindow={true} />
        <LinkBarButton linkText={environment.nativeMobileRepositoryUrl} displayText="Native Mobile" openNewWindow={true} />
        <LinkBarButton linkText={environment.webAppRepositoryUrl} displayText="Web App" openNewWindow={true} />
        <LinkBarButton linkText={environment.productionDashboardUrl} displayText="Prod Dashboard" openNewWindow={true} />
      </div>
      <div className="flex flex-col w-[80%] gap-2 mt-[2rem]">
        <h2 className="text-dark-purple text-[24px] font-bold text-center">External Links</h2>
        <LinkBarButton linkText={buildCloudWatchDashboardsUrl()} displayText="AWS" openNewWindow={true}  />
        <LinkBarButton linkText={environment.logRocketUrl} displayText="LogRocket" openNewWindow={true} />
        <LinkBarButton linkText={environment.sentryIssuesUrl} displayText="Sentry" openNewWindow={true} />
      </div>
      <div className="flex flex-col w-[80%] gap-2 mt-[2rem]">
        <h2 className="text-dark-purple text-[24px] font-bold text-center">Dev Tool Links</h2>
        <InternalLinkBarButton linkText="/fine-tuning" displayText="Model Fine-Tuning" />
        <InternalLinkBarButton linkText="/trace" displayText="Trace Platform" />
        <InternalLinkBarButton linkText="/eval" displayText="Model Evaluation" />
        <InternalLinkBarButton linkText="/external-usage" displayText="External Logs" />
      </div>
    </div>
  )
};